<div class="loginBodyContainer">
    <div class="LoginHeadderContainer">
        <p class="LoginERPTitle">{{ 'HOME.TITLE' | translate }}
          <i class="material-icons">cloud_queue</i>
        </p>
      </div>

<div class="CompanySelectPageTitle">{{ 'LoginCompanySelect.Welcome' | translate }} {{User.UserName}}</div>
<div class="CompanySelectPageSubTitle" *ngIf="this.User.Rights?.AssignedCompanies?.length > 0;">{{ 'LoginCompanySelect.SelectACompanyTitle' | translate }}</div>

<div class="example-form" style="background: #fff;margin-top: 50px;">
  
    <mat-form-field class="CompanySelectDropDown" appearance="outline" *ngIf="this.User.Rights?.AssignedCompanies?.length > 0;">
        <mat-label>{{ 'ChooseCompany' | translate }}</mat-label>
        <mat-select name="Company" [compareWith]="compareFn" [(ngModel)]="this.Company">
          <mat-option *ngFor="let c of this.User.Rights.AssignedCompanies;" [value]="c" (click)="this.Company = c;">
            {{c.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button *ngIf="this.Company != null && this.User.Rights?.AssignedCompanies?.length > 0;" mat-raised-button color="primary" class="loginButton bigButton" (click)="SelectCompany(this.Company);">
        <i class="material-icons ButtonCenterImage">login</i>
        <span>{{ 'ChooseCompany' | translate }}</span>
      </button>

      <button *ngIf="!(this.Company != null) && this.User.Rights?.AssignedCompanies?.length > 0;" mat-raised-button disabled class="loginButton bigButton">
        <i class="material-icons ButtonCenterImage">login</i>
        <span>{{ 'ChooseCompany' | translate }}</span>
      </button>

      <p class="LoginFormSubTitleError" *ngIf="this.NoCompanyAssignedError == true;">{{'NoCompanyError' | translate}}</p>
      <p class="NoAppAccessMessage" *ngIf="this.HasAppAccess == false;">{{'NoAppAccessError' | translate}}</p>

      <button *ngIf="this.HasAppAccess == false;" color="primary" mat-raised-button class="loginButton bigButton" (click)="LogOff();" style="margin-top: 20px;">
        <i class="material-icons ButtonCenterImage">check</i>
        <span>{{ 'UnderstoodButton' | translate }}</span>
      </button>

      <button *ngIf="this.HasAppAccess == true;" mat-raised-button class="loginButton bigButton" (click)="LogOff();" style="margin-top: 20px;">
        <i class="material-icons ButtonCenterImage">switch_account</i>
        <i class="material-icons ButtonCenterImage">logout</i>
        <span>{{ 'LogOffDifferent' | translate }}</span>
      </button>
</div>
</div>  
 
